export default __webpack_public_path__ + "static/media/hibernate.cd332ca2.svg";